import { createReducer } from 'redux-act';
// project files
import * as actions from './actions';
import produce from 'immer';

const initialState = {
  organizationTopics: [],
  questionTags: [],
  slides: [],
  questions: {},
  audioClips: [],
  previewSlides: [],
  previewQuestions: {},
  previewAudioClips: [],
  todaySessions: {},
  currentSessionQuestions: {},
  topic: {},
  topicsSearch: [],
};

const curriculumTopicsReducer = createReducer(
  {
    [actions.fetchOrganizationTopicsSuccess]: (state, payload) => ({
      ...state,
      organizationTopics: payload,
    }),
    [actions.addQuestionToTopicSuccess]: (state, payload) => ({
      ...state,
      questions: { data: [...(state.questions.data || []), payload] },
    }),
    [actions.updateQuestionTopicSuccess]: (state, payload) => {
      const questions = [...(state.questions.data || [])];
      const index = questions.findIndex((qsn) => qsn._id === payload._id);
      questions[index] = payload;
      return { ...state, questions: { data: questions } };
    },
    [actions.deleteTopicQuestionSuccess]: (state, payload) => {
      const list = state.questions.data.filter((qsn) => qsn._id !== payload._id);
      return {
        ...state,
        questions: { data: list },
      };
    },
    [actions.changeTopicQuestionOrderSuccess]: (state, payload) => {
      const questions = [...state.questions.data];
      const temp = questions[payload.new];
      questions[payload.new] = questions[payload.old];
      questions[payload.old] = temp;
      return {
        ...state,
        questions: { data: questions },
      };
    },
    [actions.fetchQuestiontagsSuccess]: (state, payload) => ({ ...state, questionTags: payload }),
    [actions.addQuestionTag]: (state, payload) =>
      produce(state, (draftState) => {
        draftState.questionTags.push(payload);
      }),
    [actions.updateQuestionTag]: (state, payload) =>
      produce(state, (draftState) => {
        const findIndex = draftState.questionTags.findIndex((item) => item._id === payload._id);
        draftState.questionTags[findIndex] = payload;
      }),
    [actions.addItemIntoArraySuccess]: (state, payload) =>
      produce(state, (draftState) => {
        draftState[payload.key].unshift(payload.value);
      }),

    [actions.updateItemInArraySuccess]: (state, payload) =>
      produce(state, (draftState) => {
        const findIndex = draftState[payload.key].findIndex(
          (item) => item._id === payload.value._id
        );

        draftState[payload.key][findIndex] = payload.value;
      }),
    [actions.deleteItemInArraySuccess]: (state, payload) =>
      produce(state, (draftState) => {
        const findIndex = draftState[payload.key].findIndex((item) => item._id === payload.value);
        draftState[payload.key].splice(findIndex, 1);
      }),
    [actions.fetchItemsSuccess]: (state, payload) => ({ ...state, [payload.key]: payload.value }),
    [actions.clearCurriculumTopics]: () => ({ ...initialState }),

    [actions.getTopicSuccess]: (state, payload) => ({ ...state, topic: payload }),
    [actions.getTopicByName]: (state, payload) => ({ ...state, topicsSearch: payload }),
  },
  initialState
);

export default curriculumTopicsReducer;
